
<template>
  <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
    <van-list
      v-model="loading"
      :finished="finished"
      :offset="offset"
      :immediate-check="ischeck"
      finished-text="没有更多了"
      @load="loadMore"
    >
    <div v-for="(item,index) in dataList" :key="index" >
        <div class="book-goods-section">
          <router-link :to="{path:'/BookingGoodsDetails', query: {pid: item.SerialNumber,puid : item.ProductId}}" class="book-goods-list">
            <div class="hd">
              <img :src="item.CoverPhoto" alt class="avatar" />
            </div>
            <div class="bd">
              <h2 class="title">{{item.ProductName}}</h2>
              <div class="ft">
                <div class="price">
                  ￥
                  <span class="money">{{item.Price}}</span>
                  <span class="c6">元</span>
                </div>
                <div class="num">{{item.AppointmentTotal}}人预约</div>
              </div>
            </div>
          </router-link>
        </div>
    </div>
    </van-list>
  </van-pull-refresh>
</template>


<script>
import { mapGetters, mapState } from "vuex";
export default {
  data() {
    return {
      refreshing: false,
      loading: true,
      finished: false,
      offset: 100,
      ischeck: false,
      options: null,
    //   oldmemorialhalltypeval : 1,   // 老的type 值
      dataList: [],
    };
  },
  props : {
    typeid : {
        type:Number,
        default : 0,
    },
    mid : {
        type:Number,
    }
  },
  computed: {
  },
  watch: {
},
  methods: {
    init() {
      var that = this;
      that.options = {
        type: "GetProductProductSearchList",
        Tid : that.typeid == 0 ? null : that.typeid,
        pageIndex: 1
      };
      that.getList();
    },
    loadMore() {
      // console.log("我是loadMore=====" + this.currentind);

        Object.assign(this.options, {
            pageIndex: this.options.pageIndex + 1,
        });
        this.loading = true;
        this.getList();

    },
    onRefresh() {
      // console.log("我是onRefresh======" + this.currentind);
        
        this.finished = false;
        // 重新加载数据
        // 将 loading 设置为 true，表示处于加载状态
        this.loading = true;
        Object.assign(this.options, {
            pageIndex: 1,
            ReadShowType: this.readshowtypeid,
            MemorialHallType : this.memorialhalltype,
        });
        this.getList();
        
    },
    getList() {
      // console.log("我是getList======" + this.currentind);
        var that = this;
        this.$store.dispatch(this.options).then(
          res => {
            that.loading = false;
            if (that.refreshing) {
              that.refreshing = false;
            }
            var dataList = res.ProductApiModelList;
            if (dataList.length == 0){
              that.finished = true;
            }

            if (dataList.length < 10) {
              that.finished = true;
            }
            
            if (this.options.pageIndex > 1) {
              if (dataList.length > 0) {
                dataList.forEach(element => {
                  that.dataList.push(element);
                });
              }
            } 
            else {
              that.dataList = dataList;
            }
          },
          error => {}
        );
    }
  },
  created() {
    var that = this;
    that.init();
  },
  
};
</script>

<style>
.book-goods-section {
  margin: 1.5%;
  /* overflow: hidden; */
}
.book-goods-list {
  display: block;
  background-color: #fff;
  border-radius: 6px;
  width: 47%;
  float: left;
  margin: 1.5%;
}
.book-goods-list > .hd {
  width: 100%;
  height: 0;
  font-size: 0;
  position: relative;
  padding-bottom: 100%;
}
.book-goods-list > .hd > .avatar {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 6px;
}
.book-goods-list > .bd {
  padding: 10px;
}
.book-goods-list > .bd .title {
  font-size: 15px;
  font-weight: normal;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.book-goods-list > .bd .ft {
  display: flex;
  align-items: center;
  margin-top: 4px;
}
.book-goods-list > .bd .ft .price {
  flex: 1;
  overflow: hidden;
  font-size: 12px;
  color: crimson;
}
.book-goods-list > .bd .ft .price .money {
  font-size: 16px;
}
.book-goods-list > .bd .ft .num {
  margin-left: 10px;
  font-size: 12px;
  color: #888;
}
</style>


